import LegalLayout, { Section } from "@/components/LegalLayout";
import { SITE } from "@/data/site";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      description="The terms and conditions governing your use of the Kinect Nova AI app and website."
      path="/terms"
      intro={`These Terms of Service ("Terms") govern your access to and use of the ${SITE.name} mobile application and website (the "Service"). By creating an account or using the Service, you agree to be bound by these Terms.`}
    >
      <Section heading="1. Acceptance of terms">
        <p>By accessing or using the Service, you confirm that you are at least the age of majority in your jurisdiction and that you accept these Terms and our Privacy Policy. If you do not agree, please do not use the Service.</p>
      </Section>

      <Section heading="2. Not a medical or emergency service">
        <p><strong>Kinect Nova AI is a wellness and coordination tool. It is not a substitute for professional medical advice, diagnosis or treatment, and it is not an emergency response service.</strong> Always seek the advice of a qualified health provider with any questions about a medical condition. In an emergency, always call your local emergency number (such as 911 or 112). The Emergency SOS feature depends on device, network and third-party availability and may not function in all circumstances.</p>
      </Section>

      <Section heading="3. Your account">
        <p>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. You agree to provide accurate information and to keep it up to date. Notify us immediately of any unauthorized use.</p>
      </Section>

      <Section heading="4. Acceptable use">
        <ul className="list-disc space-y-1 pl-6">
          <li>Do not use the Service for any unlawful or harmful purpose.</li>
          <li>Do not upload content that infringes the rights of others.</li>
          <li>Do not attempt to disrupt, reverse engineer or gain unauthorized access to the Service.</li>
          <li>Do not misuse emergency features or send false alerts.</li>
        </ul>
      </Section>

      <Section heading="5. Subscriptions and payments">
        <p>Some features may require a paid subscription. Subscriptions purchased through the Apple App Store or Google Play are billed and managed in accordance with those platforms' terms. Prices and features may change with notice. Auto-renewing subscriptions can be canceled through your app store account settings.</p>
      </Section>

      <Section heading="6. Intellectual property">
        <p>The Service and all related content, trademarks and software are owned by {SITE.name} or its licensors and are protected by applicable laws. We grant you a limited, non-exclusive, non-transferable license to use the Service for personal, non-commercial purposes.</p>
      </Section>

      <Section heading="7. User content">
        <p>You retain ownership of the content you submit. By submitting content, you grant us a limited license to host, store and display it solely to operate and provide the Service to you and the people you authorize.</p>
      </Section>

      <Section heading="8. Disclaimers and limitation of liability">
        <p>The Service is provided "as is" and "as available" without warranties of any kind. To the maximum extent permitted by law, {SITE.name} disclaims all warranties and shall not be liable for any indirect, incidental or consequential damages arising from your use of the Service.</p>
      </Section>

      <Section heading="9. Termination">
        <p>We may suspend or terminate your access to the Service if you violate these Terms. You may stop using the Service and delete your account at any time.</p>
      </Section>

      <Section heading="10. Governing law">
        <p>These Terms are governed by applicable law without regard to conflict-of-law principles. Any disputes shall be resolved in the appropriate courts of competent jurisdiction.</p>
      </Section>

      <Section heading="11. Changes to these terms">
        <p>We may revise these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.</p>
      </Section>

      <Section heading="12. Contact">
        <p>Questions about these Terms? Email us at {SITE.supportEmail}.</p>
      </Section>
    </LegalLayout>
  );
}
